"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _commonTabs = _interopRequireDefault(require("./common-tabs.css"));

var BaseTabs = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(BaseTabs, _React$Component);

  function BaseTabs() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BaseTabs.prototype;

  _proto.handleClick = function handleClick(index) {
    var onTabChange = this.props.onTabChange;
    this.setState({
      selectedTab: index
    });

    if (typeof onTabChange === 'function') {
      onTabChange(index);
    }
  };

  _proto.handleKey = function handleKey(index, e) {
    var tabNames = this.props.tabNames;
    var leftKey = 37;
    var rightKey = 39;
    var numTabs = tabNames.length;

    if (e.keyCode === leftKey) {
      var newIndex = (index + numTabs - 1) % numTabs;
      this.handleClick(newIndex);
      this.tabs[newIndex].current.focus();
    } else if (e.keyCode === rightKey) {
      var _newIndex = (index + 1) % numTabs;

      this.handleClick(_newIndex);

      this.tabs[_newIndex].current.focus();
    }
  };

  _proto.getTabClasses = function getTabClasses() {
    var _this$props = this.props,
        fullWidth = _this$props.fullWidth,
        variant = _this$props.variant;
    var classes = [_commonTabs["default"].tabName, _commonTabs["default"][variant + "Tab"]];

    if (fullWidth) {
      classes.push(_commonTabs["default"].fullWidthTab);
    }

    return classes;
  };

  _proto.getHorizontalListClasses = function getHorizontalListClasses() {
    var showSelectMenuIfScrollable = this.props.showSelectMenuIfScrollable;
    var classes = [];

    if (!showSelectMenuIfScrollable) {
      classes.push(_commonTabs["default"].tabsHideSelectMenu);
    }

    return classes;
  };

  _proto.isTabActive = function isTabActive(index) {
    var selectedTab = this.state.selectedTab;
    return selectedTab === index;
  };

  return BaseTabs;
}(_react["default"].Component);

exports["default"] = BaseTabs;
BaseTabs.displayName = 'BaseTabs';
BaseTabs.defaultProps = {
  variant: 'light',
  showSelectMenuIfScrollable: false,
  selectedTab: 0
};